<skip-to-content/>
<div class="app-wrapper">
  @if ((translationsLoaded$ | async) === false) {
    <loader [message]="loaderMessage"></loader>
  }
  @if ((translationsLoaded$ | async)) {
    <alerts global id="cookie"></alerts>
    @if (isNewNavigationEnabled) {
      @defer {
      <navigation></navigation>
    }
  } @else {
    @defer {
    <sidemenu></sidemenu>
  }
}
<div class="app-flex-main">
  <global-alert />
  <htm-header></htm-header>
  <div class="app-content" (click)="closeSidemenu($event)">
    <div tabindex="-1" id="content"></div>
    <alerts id="neuro-translation"></alerts>
    <router-outlet (activate)="onActivate()"></router-outlet>
    <htm-footer></htm-footer>
  </div>
  <!--/app-content-->
</div><!--/app-flex-main-->
<alerts global></alerts>
<sessionExpiration></sessionExpiration>
<digi-sign-overlay></digi-sign-overlay>
}
</div><!--/app-wrapper-->
